import { render } from "./ListDemo.vue?vue&type=template&id=78ba8803&scoped=true"
import script from "./ListDemo.vue?vue&type=script&lang=js"
export * from "./ListDemo.vue?vue&type=script&lang=js"

import "./ListDemo.vue?vue&type=style&index=0&id=78ba8803&scoped=true&lang=scss"

import exportComponent from "/var/www/amee/iptu-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78ba8803"]])

export default __exports__